import Head from 'next/head'
import Link from 'next/link'
import Footer from '../components/footer';

const handleDownload = () => {
  var localFilePath = "ADA Subscriber Disenrollment Form.pdf";
  fetch(
    "https://client-objects.s3.us-west-2.amazonaws.com/bpi-eada/ADA+Subscriber+Disenrollment+Form.pdf"
  )
    .then((response) => response.blob())
    .then((blob) => {
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", localFilePath.split("/").pop());
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    })
    .catch((error) => console.error("Error downloading file:", error));
};

const FAQ = () => {
  return (
    <div className="antialiased min-h-screen">
      <Head>
        <title>BPI eADA - FAQs</title>
        <link rel="icon" href="/favicon.png" />
        <link rel="stylesheet" href="https://use.typekit.net/hxw2jwi.css" />
      </Head>

      <div className="relative bg-transparent overflow-hidden">
        <div className="relative pt-4 pb-12 sm:pb-20">
          <div className="max-w-screen-xl mx-auto px-4 sm:px-6">
            <nav className="relative flex items-center justify-between sm:h-14 md:justify-center">
              <div className="flex items-center flex-1 md:absolute md:inset-y-0 md:left-0">
                <div className="flex items-center justify-between w-full md:w-auto">
                  <Link href="/">
                    <img
                      className="h-10 w-auto sm:h-14 cursor-pointer"
                      src="/img/BPI-logo-2022.png"
                      alt="BPI"
                    />
                  </Link>
                </div>
              </div>
              <div className="absolute flex items-center justify-end inset-y-0 right-0">
                <span className="inline-flex rounded-md shadow-none">
                  <Link href="/faq">
                    <a className="inline-flex items-center px-2 py-1.5 border border-transparent text-sm sm:text-base leading-6 font-semibold rounded-md bg-transparent text-brand-500 focus:bg-transparent outline-none focus:outline-none transition duration-150 ease-in-out">
                      FAQs
                    </a>
                  </Link>
                </span>
                <span className="inline-flex rounded-md shadow-none">
                  <Link href="/terms-and-conditions">
                    <a className="inline-flex items-center px-2 py-1.5 border border-transparent text-sm sm:text-base leading-6 font-semibold rounded-md bg-transparent text-brand-500 focus:bg-transparent outline-none focus:outline-none transition duration-150 ease-in-out">
                      Terms and Conditions
                    </a>
                  </Link>
                </span>
              </div>
            </nav>
          </div>
        </div>
        <div className="max-w-screen-xl mx-auto px-6 pb-10 text-justify">
          <h1 className="text-2xl md:text-4xl font-bold md:leading-5 text-gray-800 mb-10">
            Frequently Asked Questions
          </h1>
          <div className="mt-6 border-t-2 border-gray-100 pt-10">
            <dl className="md:grid md:grid-cols-2 md:gap-16">
              <div>
                <div>
                  <dt className="text-lg leading-6 font-semibold text-brand-700">
                    What is BPI eADA?
                  </dt>
                  <dd className="mt-2">
                    <p className="text-base leading-6 text-gray-600">
                      The BPI electronic Auto Debit Arrangement is a fully
                      digitized platform that enables clients to enroll their
                      accounts for scheduled payments with BPI’s partner
                      billers.
                    </p>
                  </dd>
                </div>
                <div className="mt-12">
                  <dt className="text-lg leading-6 font-semibold text-brand-700">
                    Who can enroll to BPI eADA?
                  </dt>
                  <dd className="mt-2">
                    <p className="text-base leading-6 text-gray-600">
                      BPI clients who have savings and checking accounts
                      enrolled in BPI Online.
                    </p>
                  </dd>
                </div>
                <div className="mt-12">
                  <dt className="text-lg leading-6 font-semibold text-brand-700">
                    How do I enroll to BPI eADA?
                  </dt>
                  <dd className="mt-2">
                    <ul className="list-none text-base leading-6 text-gray-600">
                      <li>Step 1: Visit https://bpi-ada.com/</li>
                      <li>Step 2: Choose a category and desired biller.</li>
                      <li>
                        Step 3: Input the Reference No. provided by the Biller.
                        If your Reference No. is rejected, kindly reconfirm the
                        same with your Biller or revisit your SOA.
                      </li>
                      <li>
                        Step 4: Supply your BPI Online username and password.
                      </li>
                      <li>
                        Step 5: Choose the account you wish to enroll in the
                        auto debit arrangement.
                      </li>
                      <li>Step 6: An OTP will be sent for confirmation.</li>
                      <li>
                        Step 7: A successful page will be displayed. Please
                        coordinate with the Biller on your payment schedule.
                      </li>
                    </ul>
                  </dd>
                </div>
              </div>
              <div className="mt-12 md:mt-0">
                <div>
                  <dt className="text-lg leading-6 font-semibold text-brand-700">
                    When will my payment schedule begin?
                  </dt>
                  <dd className="mt-2">
                    <p className="text-base leading-6 text-gray-600">
                      This will depend on your agreement with the biller.
                    </p>
                  </dd>
                </div>
                <div className="mt-12">
                  <dt className="text-lg leading-6 font-semibold text-brand-700">
                    Can I cancel my enrollment to BPI eADA?
                  </dt>
                  <dd className="mt-2">
                    <p className="text-base leading-6 text-gray-600">
                      Yes. Please download the ADA disenrollment form and submit
                      to any BPI branches. However, you must notify your biller
                      about your request to cancel the ADA.
                    </p>
                    <br></br>
                    <button
                      type="button"
                      onClick={handleDownload}
                      className={
                        "inline-flex items-center justify-center w-1/2 sm:w-1/4 rounded-md border border-transparent px-2 py-2 bg-brand-500 text-base leading-6 font-medium text-white shadow-sm focus:outline-none focus:border-brand-700 focus:shadow-outline-red transition ease-in-out duration-150"
                      }
                    >
                      Download Form
                    </button>
                  </dd>
                </div>
                <div className="mt-12">
                  <dt className="text-lg leading-6 font-semibold text-brand-700">
                    Can I change my eADA enrolled account?
                  </dt>
                  <dd className="mt-2">
                    <p className="text-base leading-6 text-gray-500">
                      To avoid double debit transactions, you must first cancel
                      your previous enrollment with your account. Afterwards,
                      you may enroll the new account you intend to use.
                    </p>
                  </dd>
                </div>
              </div>
            </dl>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default FAQ;
